import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {ButtonAddRowComponent} from './button-add-row/button-add-row.component';
import {ButtonConfirmComponent} from './button-confirm/button-confirm.component';
import {TranslateModule} from '@ngx-translate/core';

@NgModule({
  declarations: [ButtonAddRowComponent, ButtonConfirmComponent],
  exports: [ButtonAddRowComponent, ButtonConfirmComponent],
  imports: [
    CommonModule,
    TranslateModule.forChild()
  ]
})
export class UIModule { }
